import { render, staticRenderFns } from "./AssignCleaner.vue?vue&type=template&id=70f2d5b6&scoped=true"
import script from "./AssignCleaner.vue?vue&type=script&lang=js"
export * from "./AssignCleaner.vue?vue&type=script&lang=js"
import style0 from "./AssignCleaner.vue?vue&type=style&index=0&id=70f2d5b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2d5b6",
  null
  
)

export default component.exports